var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.95,
    height: 46.739,
    viewBox: "0 0 25.95 46.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8468",
    "data-name": "\\uADF8\\uB8F9 8468",
    transform: "translate(-430.497 -218.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27134",
    "data-name": "\\uD328\\uC2A4 27134",
    d: "M438.206,222.046c0-.581-.014-1.033,0-1.484A1.949,1.949,0,0,1,440.3,218.5q3.144-.017,6.287,0a1.965,1.965,0,0,1,2.139,2.093c.014.448,0,.9,0,1.45h5.053c2.073,0,2.67.6,2.67,2.682q0,18.9,0,37.8c0,2.049-.649,2.7-2.671,2.7q-10.406,0-20.813,0c-1.748,0-2.464-.714-2.464-2.473q0-19.114,0-38.228c0-1.835.666-2.487,2.519-2.488C434.711,222.045,436.4,222.046,438.206,222.046Zm17.172,21.609q0-9.557,0-19.115c0-1.189-.262-1.455-1.433-1.455q-10.449,0-20.9,0c-1.235,0-1.485.251-1.485,1.491q0,19.029,0,38.06c0,1.287.257,1.553,1.521,1.553q10.407,0,20.814,0c1.218,0,1.483-.272,1.483-1.5Q455.378,253.17,455.378,243.655Zm-7.762-21.648c0-.57.012-1.048,0-1.525a.876.876,0,0,0-.979-.93c-2.121-.009-4.244-.032-6.363.028a1.187,1.187,0,0,0-.879.686,6.979,6.979,0,0,0-.041,1.741Z",
    fill: "#a4a7ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27135",
    "data-name": "\\uD328\\uC2A4 27135",
    d: "M432.928,243.565q0-9.008,0-18.014c0-1.072.02-1.093,1.1-1.093h18.863c1.081,0,1.108.027,1.108,1.092q0,18.1.018,36.2c0,.841-.286,1.079-1.08,1.077q-9.474-.03-18.949,0c-.8,0-1.084-.235-1.079-1.076C432.943,255.687,432.928,249.626,432.928,243.565Zm19.979,18.106V225.565H434.031v36.106Z",
    fill: "#a4a7ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8467",
    "data-name": "\\uADF8\\uB8F9 8467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8466",
    "data-name": "\\uADF8\\uB8F9 8466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8459",
    "data-name": "\\uADF8\\uB8F9 8459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8458",
    "data-name": "\\uADF8\\uB8F9 8458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27136",
    "data-name": "\\uD328\\uC2A4 27136",
    d: "M443.471,246.458c-2.351,0-4.7-.022-7.052.013-.774.011-1.054-.258-1.025-1.034.048-1.272.032-2.548,0-3.822-.013-.639.206-.92.881-.918q7.179.024,14.358,0c.664,0,.907.255.893.906-.028,1.3-.042,2.606.005,3.907.028.774-.313.965-1.014.958C448.172,246.442,445.821,246.458,443.471,246.458Zm-6.953-1.147h13.864v-3.475H436.518Z",
    fill: "#ffd400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8461",
    "data-name": "\\uADF8\\uB8F9 8461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8460",
    "data-name": "\\uADF8\\uB8F9 8460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27137",
    "data-name": "\\uD328\\uC2A4 27137",
    d: "M443.487,253.377c-2.347,0-4.694-.023-7.04.014-.757.012-1.082-.207-1.053-1.005.047-1.271.043-2.546,0-3.817-.025-.754.291-.973,1.005-.97q7.083.03,14.167,0c.671,0,.983.206.964.922-.034,1.328-.029,2.659,0,3.987.014.672-.274.883-.918.877C448.238,253.363,445.862,253.377,443.487,253.377Zm-6.971-1.111h13.872v-3.5H436.516Z",
    fill: "#ffd400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8463",
    "data-name": "\\uADF8\\uB8F9 8463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8462",
    "data-name": "\\uADF8\\uB8F9 8462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27138",
    "data-name": "\\uD328\\uC2A4 27138",
    d: "M443.554,254.521c2.32,0,4.641.029,6.961-.016.8-.016,1.04.291,1.019,1.042-.038,1.3-.024,2.6-.007,3.9.008.6-.218.859-.85.857q-7.217-.025-14.432,0c-.639,0-.85-.27-.842-.865.016-1.33.025-2.661,0-3.99-.015-.685.227-.955.939-.945C438.743,254.541,441.149,254.521,443.554,254.521Zm-7.028,4.664h13.847v-3.572H436.526Z",
    fill: "#ffd400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8465",
    "data-name": "\\uADF8\\uB8F9 8465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8464",
    "data-name": "\\uADF8\\uB8F9 8464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27139",
    "data-name": "\\uD328\\uC2A4 27139",
    d: "M446.635,227.547c-.437,1.516-.818,2.931-1.26,4.327a.755.755,0,0,0,.423,1.072c2.175,1.12,1.651,1.255.22,2.535-1.475,1.32-2.924,2.669-4.412,3.973a2.913,2.913,0,0,1-.926.355,2.764,2.764,0,0,1-.1-.979c.331-1.194.715-2.374,1.114-3.548.158-.468.132-.777-.36-1.025a12.183,12.183,0,0,1-1.353-.869c-.418-.284-.466-.633-.086-.979,1.922-1.753,3.845-3.5,5.789-5.234a.8.8,0,0,1,.681-.093C446.509,227.135,446.571,227.427,446.635,227.547Zm-1.578,1.6-4,3.667c.483.31.869.6,1.291.82a1.009,1.009,0,0,1,.522,1.459c-.292.754-.5,1.54-.82,2.534l3.779-3.431c-.431-.262-.752-.5-1.105-.664a.934.934,0,0,1-.569-1.351C444.491,231.271,444.718,230.318,445.057,229.151Z",
    fill: "#ffd400"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.5fd742c9ffaa5aa60f05aa492a495a54.svg";
export { ForwardRef as ReactComponent };